import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';
import ModalConfigStore from './ModalConfig/ModalConfigStore';
import ProductStore from './ProductStore';
import * as constants from 'Constants';
import * as utils from 'Utils';


class PageStore {

  @setter @observable id;
  @setter @observable platform;
  @setter @observable tagsWhitelist;
  @setter @observable tagsBlacklist;
  @setter @observable modalConfig;
  @setter @observable cssStyles;

  @setter @observable product;
  @setter @observable onReadyCallback;
  @setter @observable isFreePlan;

  constructor() {
    this.reset();
  }

  @action reset() {
    this.id = null;
    this.platform = "";
    this.tagsWhitelist = [];
    this.tagsBlacklist = [];
    this.modalConfig = new ModalConfigStore();
    this.cssStyles = "";

    this.product = new ProductStore();
    this.onReadyCallback = null;
    this.isFreePlan = null;
  }

  getDeserializeMappers() {
    return [
      {"field": "id", "accessor": "back_in_stock.id"},
      {"field": "platform", "accessor": "back_in_stock.platform"},
      {"field": "tagsWhitelist", "accessor": "back_in_stock.tags_whitelist"},
      {"field": "tagsBlacklist", "accessor": "back_in_stock.tags_blacklist"},
      {"field": "modalConfig", "accessor": "back_in_stock.modal_config", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ModalConfigStore},
      {"field": "cssStyles", "accessor": "back_in_stock.css_styles"},

      {"field": "product", "accessor": "product", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": ProductStore},
      {"field": "isFreePlan", "accessor": "is_free_plan"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
    this.setShopwareProductTags(data);
  }

  @action async deserializeProduct(data) {
    let product = new ProductStore();
    await product.deserialize(data);
    this.product = product;
  }

  @action setFields(data) {
    let self = this;
    for (var key in data) {
      let value = data[key];
      self[key] = value;
    }
  }

  @action setShopwareProductTags(data) {
    if (!this.isShopware) return;
    if (window.OnVoardData.product && window.OnVoardData.product.tags) return;
    if (!data.product_tags) return;
    window.OnVoardData.product.tags = data.product_tags || [];
  }

  @computed get selectorPath() {
    return `.ov-app-back-in-stock[data-app-id="${this.id}"]`;
  }

  @computed get selector() {
    return document.querySelector(this.selectorPath);
  }

  @computed get isShopify() {
    return this.platform === "shopify";
  }

  @computed get isBigCommerce() {
    return this.platform === "bigcommerce";
  }

  @computed get isEasyStore() {
    return this.platform === "easystore";
  }

  @computed get isShopline() {
    return this.platform === "shopline";
  }

  @computed get isShopware() {
    return this.platform === "shopware";
  }

  @computed get isWix() {
    return this.platform === "wix";
  }

  @computed get isWooCommerce() {
    return this.platform === "woocommerce";
  }

  @computed get isOtherPlatforms() {
    return this.platform === "others";
  }

  @computed get hasOutOfStock() {
    if (this.product.outOfStock) return true;
    if (this.product.variants.some((variant) => variant.outOfStock)) return true;
    return false;
  }
}


const pageStore = new PageStore();
export default pageStore;
export { PageStore };
